// The homepage sections that can be shown, hidden and reordered (Website → Homepage →
// "Section order"). The hero stays at the top. Each id is rendered in src/components/HomePage.jsx.
// The saved layout is { order: [ids], hidden: [ids] } per language (see homeDefaults/layout.js).
export const HOME_SECTIONS = [
  { id: "about", label: "About section" },
  { id: "team", label: "Team & reviews" },
  { id: "whyChooseUs", label: "Why choose us" },
  { id: "services", label: "Services" },
  { id: "coverageMap", label: "Coverage map" },
  { id: "testimonial", label: "Testimonial" },
  { id: "blog", label: "Blog" },
  { id: "faq", label: "FAQ" },
  { id: "cases", label: "Case studies" },
  { id: "seoText", label: "Long text (SEO)" },
  { id: "cta", label: "Closing call to action" },
];

const KNOWN = new Set(HOME_SECTIONS.map((s) => s.id));

/** Every section, in the saved order (unknown ids dropped, new sections added at the end), hidden or not. */
export function sectionOrderAll(layout) {
  const saved = [...new Set(layout?.order || [])].filter((id) => KNOWN.has(id));
  return [...saved, ...HOME_SECTIONS.map((s) => s.id).filter((id) => !saved.includes(id))];
}

/** The ids to show on the page, in order. */
export function sectionOrder(layout) {
  const hidden = new Set(layout?.hidden || []);
  return sectionOrderAll(layout).filter((id) => !hidden.has(id));
}
